import api from '..'

const requests = {
    fetchPlaylists: async ({ search, sortKey, sortType, pageSize, pageNo, genreId }) => {
        var response = await api.get(`/wellful/Playlist/`, {
            params: {
                search,
                sortKey,
                sortType,
                pageSize,
                pageNo,
                genreId
            }
        })

        return response.data
    },
    fetchPlaylist: async (id) => {
        var response = await api.get(`/wellful/Playlist/${id}`)
        return response.data
    },
    createPlaylist: async (payload) => {
        var response = await api.post(`/wellful/Playlist`, payload)
        return response.data
    },
    updatePlaylist: async (payload) => {
        var response = await api.put(`/wellful/Playlist/${payload.id}`, payload)
        return response.data
    },
    updateContentPageImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Playlist/${id}/ContentPageImage`, formData, {
            headers: {
                'content-Type': 'multipart/form-data'
            }
        })
    },
    updateHomePageImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Playlist/${id}/HomePageImage`, formData, {
            headers: {
                'content-Type': 'multipart/form-data'
            }
        })
    },
    updateMenuImage: async (id, payload) => {
        var formData = new FormData()

        formData.append('file', payload.file)

        return api.put(`/wellful/Playlist/${id}/MenuImage`, formData, {
            headers: {
                'content-Type': 'multipart/form-data'
            }
        })
    },
    addSession: async (payload) => {
        var response = await api.put(`/wellful/Playlist/${payload.playlistId}/AddSession`, payload)
        return response.data
    },
    removeSession: async (payload) => {
        var response = await api.delete(`/wellful/Playlist/${payload.playlistId}/RemoveSession`, {
            data: payload
        })
        return response.data
    },
    setReady: async (payload) => {
        var response = await api.put(`/wellful/Playlist/${payload.id}/Ready`, payload)
        return response.data
    },
    setOnHold: async (payload) => {
        var response = await api.put(`/wellful/Playlist/${payload.id}/Retire`, payload)
        return response.data
    }
}

export default requests
